// Resolve backend HTTP and WebSocket base URLs.
//
// In self-deploy mode, REACT_APP_BACKEND_URL is intentionally empty so the
// frontend talks to the same origin (the bundled nginx proxies /api/* and
// /api/ws/* to the backend container). For WebSocket connections we still
// need an absolute ws:// or wss:// URL — derived from window.location at
// runtime when the env var is empty.
//
// In legacy preview / split-domain mode, REACT_APP_BACKEND_URL is the full
// `https://api.example.com` URL; we just convert the scheme.

const RAW = (process.env.REACT_APP_BACKEND_URL || '').trim();

/**
 * HTTP origin to use as the prefix for `/api/...` calls.
 * Empty string means "use same origin" (relative URLs).
 */
export const BACKEND_URL = RAW;

/**
 * WebSocket origin (always returns an absolute ws:// or wss:// URL).
 * Falls back to deriving from window.location when REACT_APP_BACKEND_URL is empty.
 */
export const WS_URL = (() => {
    if (RAW) {
        return RAW.replace(/^https:\/\//, 'wss://').replace(/^http:\/\//, 'ws://');
    }
    if (typeof window !== 'undefined' && window.location) {
        const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
        return `${proto}//${window.location.host}`;
    }
    return '';
})();

/** Convenience: REST API base, e.g. "" or "https://api.example.com/api". */
export const API_BASE = `${BACKEND_URL}/api`;
